// src/services/api/vision.js
import { API_CONFIG } from './config';
import { apiClient } from './client';

class VisionApi {
  async analyzeImage(imageData) {
    const response = await apiClient.request(
      API_CONFIG.ENDPOINTS.VISION.ANALYZE_IMAGE,
      {
        method: 'POST',
        body: JSON.stringify({ image: imageData })
      }
    );
    return response;
  }
}

export const visionApi = new VisionApi();